var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToiletCoral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 131.559 131.559",
    style: {
      enableBackground: "new 0 0 131.559 131.559"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Toilet_b_-_Coral"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M33.151,41.457h10.734 c2.79,0,5.166,2.031,5.6,4.787l4.48,28.437c0.271,1.72-1.059,3.276-2.8,3.276h-4.434l-2.559,35.236 c-0.108,1.482-1.341,2.629-2.827,2.629H33.15"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M33.149,41.457H22.415 c-2.79,0-5.166,2.031-5.6,4.787l-4.48,28.437c-0.271,1.72,1.059,3.276,2.8,3.276h4.434l2.559,35.236 c0.108,1.482,1.341,2.629,2.827,2.629h8.195"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    cx: 33.151,
    cy: 24.674,
    r: 8.938
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 33.151,
    y1: 82.457,
    x2: 33.151,
    y2: 114.791
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 66.626,
    y1: 20.03,
    x2: 66.626,
    y2: 111.53
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M98.103,41.457h9.37 c3.576,0,6.62,2.602,7.177,6.135l3.977,25.246c0.424,2.689-1.655,5.12-4.376,5.12h0c-1.183,0-1.954,1.241-1.431,2.302 l6.273,12.711c0.523,1.061-0.248,2.302-1.431,2.302h-6.904c-0.88,0-1.594,0.712-1.596,1.592l-0.037,16.329 c-0.108,1.482-1.341,2.629-2.827,2.629h-8.195"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M98.102,41.457h-9.37 c-3.576,0-6.62,2.602-7.177,6.135l-3.977,25.246c-0.424,2.689,1.655,5.12,4.376,5.12h0c1.183,0,1.954,1.241,1.431,2.302 L77.114,92.97c-0.523,1.061,0.248,2.302,1.431,2.302h6.903c0.88,0,1.594,0.712,1.596,1.592l0.037,16.329 c0.108,1.482,1.341,2.629,2.827,2.629h8.195"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    cx: 98.103,
    cy: 24.674,
    r: 8.938
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 98.103,
    y1: 95.272,
    x2: 98.103,
    y2: 114.791
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M89.055,24.674 c0-4.936,4.001-8.937,8.938-8.937c4.936,0,8.938,4.001,8.938,8.937"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M115.868,33.612 c-4.936,0-8.938-4.001-8.938-8.938"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M80.337,33.612 c4.936,0,8.938-4.001,8.938-8.938"
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 78.545,
    y1: 95.272,
    x2: 117.661,
    y2: 95.272
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#F18C7E",
      strokeWidth: 4,
      strokeMiterlimit: 10
    },
    d: "M113.11,129.559H18.449 C9.364,129.559,2,122.195,2,113.11V18.449C2,9.364,9.364,2,18.449,2h94.662c9.084,0,16.449,7.364,16.449,16.449v94.662 C129.559,122.195,122.195,129.559,113.11,129.559z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToiletCoral);
export default __webpack_public_path__ + "static/media/Toilet - Coral.60971ccf1055485053a2a508c4595a37.svg";
export { ForwardRef as ReactComponent };